import SupportedSocialMediaContext from './contex';
import { SupportedSocialMediaProviderProps } from './supported-social-media-context';
import { AccountTargetSupportedSocialMedia } from '@/types/account-targert-supported-social-media/account-targert-supported-social-media';
import { getAccountTargetSupportedSocialMedia } from '@/services/social-media/social-media';
import { useLayoutEffect, useState, useMemo, useRef } from 'react';

export const SupportedSocialMediaProvider: React.FC<SupportedSocialMediaProviderProps> = ({ children, defaultValues }) => {

  const [socialMedia, setSocialMedia] = useState<AccountTargetSupportedSocialMedia[]>(defaultValues?.socialMedia || []);
  const firstRender = useRef(true);

  useLayoutEffect(() => {
    if (!firstRender.current || socialMedia.length > 0) {
      return;
    }
    firstRender.current = false;
    const fetchSocialMedia = async () => {
      try {
        const socialMedia = await getAccountTargetSupportedSocialMedia({ domain: import.meta.env.VITE_DOMAIN });
        setSocialMedia(Array.isArray(socialMedia) && socialMedia?.length > 0 ? socialMedia : []);
      } catch (error) {
        console.error(error);
      }
    }
    fetchSocialMedia();
  }, [socialMedia]);

  const values = useMemo(() => ({
    socialMedia,
  }), [socialMedia]);

  return (
    <SupportedSocialMediaContext.Provider value={values}>
      {children}
    </SupportedSocialMediaContext.Provider>
  );
};
